module.exports = __webpack_public_path__ + "img/nuxt-logo.5f7f582.svg";